<div class="modal-header">
  <h4 class="modal-title">
    {{ 'elbridge.send.title' | translate }}
  </h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{'elbridge.send.label' | translate}}:</p>

    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-6 col-form-label text-end font-weight-bold" for="repeatStepper">
          {{'elbridge.send.count' | translate}}:
        </label>
        <div class="col-md-3">
          <input class="form-control" type="text" id="repeatStepper"
            inputRestricter="^[0-9]{0,2}$"
            (change)="repeatStepperCheck()"
            formControlName="repeatStepper">
        </div>
      </div>
    </form>
  </div>
</div>

<div class="modal-footer" >
  <button class="btn btn-primary btn-forward"
          type="submit"
          [disabled]="form.invalid"
          appActionLogId="elbridge.send"
          (click)="submit()">
    {{'global.label.apply' | translate}}
  </button>
</div>
